import Hold from '../../../assets/hold.svg';

const HoldIcon = (props: React.SVGProps<SVGSVGElement> & { disabled?: boolean }): JSX.Element => {
  return <Hold fill={props.disabled ? '#868A90' : 'white'} {...props} />;
};

export default HoldIcon;
